import React, { useEffect } from 'react';

import Filters from './components/LeagueFilter';
import Results from './components/LeagueResults';
import $ from 'jquery'
import initFilters from './includes/jquery-filters';
window.jquery = window.$ = $

export default function () {

    useEffect(() => {
        if($){
            initFilters();
         }
       },[$]);

    return [
        <Filters key="filters" />,
        <Results key="results" />,
    ];
}
